<template>
<v-card flat class='my-4'>
  <v-card-title class='py-0 overline grey lighten-4' >
    <v-btn flat
      :disabled='window === 0'
      @click='window=0' small >
      <v-icon small >chevron_left</v-icon>
      back</v-btn>
    <v-divider vertical class='mr-2' />
    <span v-text='title' />
    <v-spacer />
    <v-btn small icon v-if='withClose' @click="$emit('close')" >
      <v-icon>close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider/>

  <v-list dense dark >
  <v-list-tile v-if='selectedLocation' >
    <v-list-tile-avatar>
      <v-icon>location_on</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>

      <v-list-tile-title v-if='selectedLocation.name' >
        Moving: {{selectedLocation.name}}:
        <span v-if='fromSpace' > from {{fromSpace.title}}</span>

        <v-icon small >arrow_forward</v-icon>

        <span v-if='toSpace' > to {{toSpace.title}}</span>
      </v-list-tile-title>

      <v-list-tile-sub-title v-if='selectedLocation.address' >
        {{selectedLocation.address}}
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action >
      <v-btn
        v-if='window===0'
        :disabled='!toSpace || !toSpace.id'
        :loading='requests.setproducts.loading'
        color='primary' class='px-2'
        @click="move" >
          Move location
      </v-btn>
      <v-btn
        @click="setProducts"
        color='primary' class='px-2'
        v-if='window===1' >
        Set appointment types
      </v-btn>
    </v-list-tile-action>

  </v-list-tile>
  </v-list >
  <!-- {{payload}} -->
  <v-window v-model="window" >

    <v-window-item >
      <v-card flat >
        <v-card-title class='subtitle-1' >
          Which space would you like to move this location to
        </v-card-title>
        <v-card-text>
          <!-- <pre v-text="value" /> -->
          <space-picker is-owner
            v-model='selectedSpace'
            :multiple='false'
            :attrs='attrs'
            label='Choose a space' />
          <!-- {{selectedSpace}} -->
        </v-card-text>
      </v-card>
    </v-window-item >

    <v-window-item >
      <v-card flat >
        <v-card-title v-if='toSpace && selectedLocation' class='subtitle-1' >
          Set the appointment types for {{selectedLocation.name}} at {{toSpace.title}}
        </v-card-title>

        <v-layout >
          <v-flex xs12 sm6 class="px-4" v-if='fromSpace && toSpace' >
            <h3 class='subheading pl-0' >
              1. Which appointment types would you like to
              {{action}}:<br/>
              from: <strong>{{fromSpace.title}}</strong>
              to: <strong>{{toSpace.title}}</strong>
            </h3>
            <v-alert :value='true' type="info" class='pa-1 my-2' dismissible >
              This will {{action}} the selected appointment types from this space to the new space
            </v-alert>

            <v-radio-group v-model="action" row class="pa-0 ma-0" >
              <v-radio hide-details label="Move" value="move" ></v-radio>
              <v-radio hide-details label="Copy" value="copy" ></v-radio>
            </v-radio-group>

            <!-- <pre v-text='fromSpace' /> -->
            <template v-for='product in fromSpace.products' >
              <v-checkbox hide-details
                v-model='moveProducts'
                class='caption'
                :key='product.id'
                :value='product.id'
                :label='product.title' />
            </template>
          </v-flex>
          <v-divider vertical />
          <v-flex xs12 sm6 class="px-4" v-if='toSpace' >
            <h3 class='subheading pl-0' >
              2. Which appointment types (available in {{toSpace.title}})<br/>
              would you like to assign to this location
            </h3>

            <v-alert dismissible tile dense type='info' :value='true' class='pa-1 my-2' >
              This will make the selected appointment type available in this location
            </v-alert>

            <template v-for='product in getProducts(toSpace.products)' >

              <!-- <v-subheader
                v-if='isNewOwner(product.owner)'
                :key='`header-${product.owner}`'
                class='overline py-0 grey lighten-4' >
                {{ getPractitionerById(product.owner).full_name }}
              </v-subheader> -->
              <v-checkbox hide-details
                v-model='assignProducts'
                class='caption'
                :key='product.id'
                :value='product.id'
                :label='getLabel(product)' />
                <!-- P:{{product.owner}} -->
            </template>
            <!-- {{selectedProducts}} -->
          </v-flex>
        </v-layout>
      </v-card>
    </v-window-item >
  </v-window>
  <!-- <v-card-actions >
    <v-btn @click='window--' >back</v-btn>
    <v-spacer/>
    <v-btn @click='window++' >next</v-btn>
  </v-card-actions> -->
</v-card>
</template>
<script>
import SpacePicker from '@/components/pickers/SpacePicker.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'MoveLocation',
  components: {
    SpacePicker
  },
  props: {
    value: { type: Object },
    fromSpace: { type: Object, required: true },
    withClose: { type: Boolean, default: false }
  },
  data () {
    return {
      action: 'move',
      window: 0,
      selectedSpace: null,
      moveProducts: [],
      assignProducts: [],
      selectedLocation: null,
      attrs: {
        returnObject: true
      },
      requests: {
        move: {
          resource: 'ag.spaces.practitioner',
          extra: 'actions/transfer_location',
          method: 'post'
        },
        setproducts: {
          resource: 'ag.addresses',
          extra: 'actions/set_products',
          method: 'post'
        }
      }
    }
  },
  methods: {
    getProducts (productIds) {
      if (!productIds) { return [] }

      return productIds.map((id) => {
        return this.getProductById(id)
      }).filter((product) => {
        if (product) {
          return !product.archived
        }
        return false
      }).sort((a, b) => {
        if (a.owner < b.owner) { return -1 }
        return 1
      })
    },
    getLabel (product) {
      let label = product.title
      if (product.owner) {
        let p = this.getPractitionerById(product.owner)
        if (p) { label = `${label} with ${p.full_name}` }
      }
      return label
    },
    move () {
      let data = {
        location: this.selectedLocation.id,
        new_space: this.toSpace.id
      }
      this.requests.move.data = data
      this.requests.move.resourceId = this.fromSpace.id
      this.$request('save', this.requests.move)
    },
    setProducts () {
      this.requests.setproducts.data = this.payload
      this.requests.setproducts.resourceId = this.selectedLocation.id
      this.$request('save', this.requests.setproducts)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.selectedLocation = this.value
      }
    },
    moveRequestStatus () {
      if (this.moveRequestStatus === 200) {
        this.$emit('moved')
        this.window++
      }
    },
    setProductStatus () {
      if (this.setProductStatus === 200) {
        this.$emit('setproducts')
        this.$emit('close')
      }
    }
  },
  computed: {
    ...mapGetters([
      'spaces',
      'getLocations',
      'getSpaceById',
      'getProductById',
      'getPractitionerById'
    ]),
    moveRequestStatus () { return this.requests.move.status },
    setProductStatus () { return this.requests.setproducts.status },
    title () {
      if (this.selectedLocation) {
        let msg = 'Move location <b>' + this.selectedLocation.name + '</b>'
        if (this.toSpace) {
          msg += ' to <b>' + this.toSpace.title + '</b>'
        }
        return msg
      }
    },
    payload () {
      let data = {}
      if (this.fromSpace && this.toSpace) {
        data = {
          old_space: this.fromSpace.id,
          new_space: this.toSpace.id
        }
        let assign = this.assignProducts
        if (assign && assign.length > 0) {
          data['assign_products'] = assign.join(',')
        }
        let move = this.moveProducts
        if (move && move.length > 0) {
          let key = 'move_products'
          if (this.action === 'copy') { key = 'copy_products' }
          data[key] = move.join(',')
        }
      }
      return data
    },
    toSpace () {
      return this.selectedSpace
    }
  }
}
</script>



// WEBPACK FOOTER //
// MoveLocation.vue?9235fa0a